import bunionplastyBase from '../themes/bunionplasty/base';
import voomBase from '../themes/voom/base';

export default process.env.THEME === 'voom' ? voomBase : bunionplastyBase;
